import { render, staticRenderFns } from "./ValueAddedService.vue?vue&type=template&id=04a57a84&scoped=true&"
import script from "./ValueAddedService.vue?vue&type=script&lang=js&"
export * from "./ValueAddedService.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/AboutUs-pc.css?vue&type=style&index=0&id=04a57a84&scoped=true&lang=css&"
import style1 from "../assets/css/AboutUs-phone.css?vue&type=style&index=1&id=04a57a84&scoped=true&lang=css&"
import style2 from "./ValueAddedService.vue?vue&type=style&index=2&id=04a57a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a57a84",
  null
  
)

export default component.exports